import React, { useState } from 'react';
import { products, contactInfo } from '../mock';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Package, Ruler, Layers, Palette, Phone } from 'lucide-react';

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tümü');

  const categories = ['Tümü', ...new Set(products.map(p => p.category))];
  
  const filteredProducts = selectedCategory === 'Tümü' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  return (
    <div className="min-h-screen pt-24 pb-16">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-50 to-gray-100 py-16 mb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-4">
            Ürünlerimiz
          </h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Her ihtiyacınıza uygun çözümler. Kargo Poşeti, Torba, Koli Bandı, Jelatin.
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Category Filter */}
        <div className="flex flex-wrap gap-4 mb-12 justify-center">
          {categories.map((category) => (
            <Button
              key={category}
              onClick={() => setSelectedCategory(category)}
              variant={selectedCategory === category ? 'default' : 'outline'}
              className={`rounded-full px-6 py-2 ${
                selectedCategory === category
                  ? 'bg-[#E31E24] hover:bg-[#C01A1F] text-white'
                  : 'hover:border-[#E31E24] hover:text-[#E31E24]'
              }`}
            >
              {category}
            </Button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product) => (
            <Card key={product.id} className="group hover:shadow-2xl transition-all duration-300 overflow-hidden border-0 rounded-none">
              <div className="relative h-64 overflow-hidden bg-gray-100">
                <img
                  src={`${product.image}?w=600&q=80`}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-[#E31E24] text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {product.category}
                </div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-bold mb-4 group-hover:text-[#E31E24] transition-colors">
                  {product.name}
                </h3>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-center gap-3 text-gray-700">
                    <Ruler className="w-5 h-5 text-[#E31E24]" />
                    <span className="text-sm">Boyut: {product.size}</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-700">
                    <Layers className="w-5 h-5 text-[#E31E24]" />
                    <span className="text-sm">Kalınlık: {product.thickness}</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-700">
                    <Palette className="w-5 h-5 text-[#E31E24]" />
                    <span className="text-sm">Renk: {product.color}</span>
                  </div>
                </div>

                {product.features && product.features.length > 0 && (
                  <div className="mb-6">
                    <h4 className="font-semibold mb-2 text-sm text-gray-700">Özellikler:</h4>
                    <ul className="space-y-1">
                      {product.features.map((feature, index) => (
                        <li key={index} className="text-sm text-gray-600 flex items-start gap-2">
                          <span className="text-[#E31E24] mt-1">•</span>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <span className="text-lg font-bold text-[#E31E24]">{product.price}</span>
                  <Button 
                    asChild
                    className="bg-[#E31E24] hover:bg-[#C01A1F] text-white rounded-lg"
                  >
                    <a 
                      href={`https://wa.me/${contactInfo.whatsapp}?text=Merhaba, ${encodeURIComponent(product.name)} hakkında bilgi almak istiyorum.`}
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      <Phone className="w-4 h-4 mr-2" />
                      İletişime Geç
                    </a>
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-20 bg-gradient-to-r from-[#E31E24] to-[#C01A1F] rounded-3xl p-12 text-white text-center">
          <h2 className="text-3xl font-bold mb-4">Özel Boyut ve Tasarım mı Arıyorsunuz?</h2>
          <p className="text-lg mb-8 max-w-2xl mx-auto">
            İhtiyaçlarınıza özel üretim yapabiliyoruz. Minimum sipariş miktarları ve fiyat bilgisi için bizimle iletişime geçin.
          </p>
          <Button size="lg" className="bg-white text-[#E31E24] hover:bg-gray-100 rounded-lg px-8 py-6 text-lg">
            Teklif Al
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Products;
